import { Icon } from "@circle-react-shared/Icon";
import { SanitizeHTMLString } from "@circle-react-uikit/SanitizeContent";

interface ImageUploadProps {
  description?: string;
  onUpload?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const ImageUpload = ({ description, onUpload }: ImageUploadProps) => (
  <div className="bg-secondary border-primary aspect-video w-full rounded-lg border border-dashed">
    <button
      type="button"
      className="text-dark flex size-full flex-col items-center justify-center gap-2 px-4 py-5 text-center"
      onClick={onUpload}
    >
      <div className="bg-tertiary flex size-8 items-center justify-center rounded-full">
        <Icon type="plus" viewBox="0 0 20 20" />
      </div>
      <span className="mt-0.5 text-xs">
        <SanitizeHTMLString content={description} />
      </span>
    </button>
  </div>
);
